import React from 'react';
import { TextField, Button, Typography, Container, Box, Stack, Avatar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setAuthUsername } from '../../service/actions/index';
import MailIcon from '@mui/icons-material/Mail';
import InputAdornment from '@mui/material/InputAdornment';

const Login = ({ switchToPassword }) => {

  const dispatch = useDispatch();
  const email = useSelector((state) => state.inputValue);

  const handleChange = (e) => {
    dispatch(setAuthUsername(e.target.value));
  };
  return (
    <Container maxWidth="xs">
      <form onSubmit={() => { return false; }}>
      <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

      <Avatar 
        alt="Logo" 
        src="logo.png" 
        variant="rounded"
        sx={{
            height: 134,
            width: 134,
            maxHeight: { xs: 233, md: 167 },
            maxWidth: { xs: 350, md: 250 },
          }} />
       
        <Typography component="h1" variant="h5" sx={{ mt: 1 }}>
          Sign in
        </Typography>
        <Typography component="p" sx={{ mt: 1 }}>
          to your InspectReply AI account
        </Typography>

        <Box component="form" sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoFocus
            value={email}
            onChange={handleChange}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                event.stopPropagation();
                switchToPassword();
                return false;
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <MailIcon />
                </InputAdornment>
              ),
            }}
          />
          <Stack direction="row" justifyContent="end" spacing={2} sx={{ mt: 2 }}>
            <Button
              component="label"
              variant="contained"
              onClick={switchToPassword}
              sx={{ mt: 3, mb: 2, borderRadius: 28, ml: "auto" }}
            >
              Continue
            </Button>
          </Stack>
        </Box>
      </Box>
      </form>
    </Container>
  );
};

export default Login;